// extracted by mini-css-extract-plugin
export var container = "AppContainer-module--container--6f963";
export var footer = "AppContainer-module--footer--7edff";
export var header = "AppContainer-module--header--a52ee";
export var title = "AppContainer-module--title--0e376";